import { merge, map } from 'lodash';
import {
  getDeskTopAppList
} from '../services/api';

export default {
  namespace: 'desktop',
  state: {
    componentInfoList: [], // 存储已选的"组件"
    rightAppIdList: [], // 存储右侧"App菜单"
    oenAppIdPage: [], // 已经打开的App
    nowOpenPageId: '', // 当前打开的App
    applicationList: [] // 有权限的app列表
  },

  effects: {
    *getDeskTopAppList({ payload }, { call, put }) {
      const response = yield call(getDeskTopAppList, payload);
      yield put({
        type: 'fetchDeskTopAppList',
        payload: response
      });
    }
  },

  reducers: {
    clearData() {
      return {
        componentInfoList: [], // 存储已选的"组件"
        rightAppIdList: [], // 存储右侧"App菜单"
        oenAppIdPage: [], // 已经打开的App
        nowOpenPageId: '', // 当前打开的App
        applicationList: []
      };
    },
    // 获取app列表
    fetchDeskTopAppList(state, action) {
      return {
        ...state,
        applicationList: (action.payload && action.payload.list) || []
      };
    },
    // 更新桌面看板
    updateBoard(state, { payload }) {
      const componentInfoList = merge([], payload.componentInfoList);
      return { ...state, componentInfoList };
    },
    // 更新其他子组件app列表
    updateDeskTopConfig(state, { payload }) {
      const deskTopConfig = merge({}, payload);
      return { ...state, ...deskTopConfig };
    },
    // 点击app打开默认页面
    openNewAppId(state, { payload }) {
      const arr = merge([], state.oenAppIdPage);
      if (arr.indexOf(payload.newId) < 0) {
        arr.push(payload.newId);
      }
      return { ...state, oenAppIdPage: arr, nowOpenPageId: payload.newId };
    },
    // 切换App
    cutNewAppId(state, { payload }) {
      return { ...state, nowOpenPageId: payload.newId };
    },
    // 删除程序坞app
    deleteAppId(state, { payload }) {
      let { nowOpenPageId } = state;
      if (nowOpenPageId === payload.appId) {
        nowOpenPageId = false;
      }
      let isNullLen = 0;
      let oenAppIdPage = map(state.oenAppIdPage, (item) => {
        const appId = item !== payload.appId ? item : null;
        if (!appId) isNullLen += 1;
        return appId;
      });
      if (oenAppIdPage.length === isNullLen) {
        oenAppIdPage = [];
      }
      return { ...state, oenAppIdPage, nowOpenPageId };
    }
  }
};
